import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Input } from '@/components/ui/input'

interface StringFieldProps {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export const StringField = ({ field, value, onChange }: StringFieldProps) => {
  return (
    <Input
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="h-12 text-sm font-medium focus-visible:ring-primary/20"
      placeholder={field.placeholder}
    />
  )
}
